import { getUserToken } from "src/utils/jwtToken";
import useSWR from "swr";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";
import { TokenStatus } from "../types";

export type WebinarPromotionTeamMember = {
  user_id: number;
  email: string;
  first_name: string;
  last_name: string;
  order: number;
  enabled: boolean;
  token_status: TokenStatus;
};

export function useWebinarPromotionRoutingLogic(templateId?: number | string) {
  const accessToken = getUserToken();
  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  const { data, error, mutate, isValidating } = useSWR(
    templateId
      ? `/api/webinars/template/${templateId}/promotion-routing-logic`
      : null,
    (url: string) =>
      service
        .get(url)
        .set(headers)
        .then(tokenRefreshHandler)
        .then((res: Response) => res.body)
        .catch(errorHandler),
  );

  return {
    data: data as WebinarPromotionTeamMember[] | undefined,
    error,
    // Loading is true only when we're validating AND we don't have data yet (undefined)
    // If data is null or [], that means the API responded, so we're not loading
    loading: isValidating && data === undefined,
    mutate,
  };
}
